module.exports = __webpack_public_path__ + "img/tiles-icon.b378da07.svg";